// import firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";
import announcements from "@/frame/messages/mixins/announcements.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import btnControl from "@/frame/animation/mixins/btnControl.js";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import statsFunctions from "@/data/functions/mixins/statsFunctions.js";

export default {
  data() {
    return {
      userAccessList: []
    };
  },
  // eslint-disable-next-line
  mixins: [
    announcements,
    dataSources,
    btnControl,
    statsFunctions,
    getData
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getDetail",
      "getDetailBasic",
      "getDetailChar",
      "getUser",
      "getAssetRegister"
    ])
  },
  methods: {
    changeFirebaseDocumentBasicAct(db, did, value) {
      // const db = this.defineDataSourceFromTag(tag);
      let t = this;
      // console.log("FIREBASE DOC DIRECT CHANGE ACTIVE");
      // console.log(db);
      // console.log(did);
      // console.log(value);
      // eslint-disable-next-line
      db.doc(did).update({'basic.act': value}).then().catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    changeBasicSave(db, did, value) {
      // const db = this.defineDataSourceFromTag(tag);
      let t = this;
      // console.log("");
      // console.log("<<< FIREBASE DOC DIRECT CHANGE BASIC.SAVE >>>");
      // console.log(db);
      // console.log(did);
      // console.log(value);
      // eslint-disable-next-line
      db.doc(did).update({'basic.save': value}).then().catch(error => {
          t.showSnackbar(error.message, "errorDDD");
          // Reset Store
        });
    },
    changeBasicList(db, did, value) {
      // const db = this.defineDataSourceFromTag(tag);
      let t = this;
      // console.log("");
      // console.log("<<< FIREBASE DOC DIRECT CHANGE BASIC.LIST >>>");
      // console.log(db);
      // console.log(did);
      // console.log(value);
      // eslint-disable-next-line
      db.doc(did).update({'basic.list': value}).then().catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    changeUserAccessLockStatus(userdid, status) {
      console.log("GET STATS REMOTE");
      console.log("DID : " + userdid);
      console.log("STATUS : " + status);
      const db = this.defineDataSourceFromTag("G5");
      let stats = null;
      let t = this;
      // console.log("GET DOC DIRECT");
      // console.log(db);
      // console.log(did);
      // eslint-disable-next-line
      db.doc(userdid).get().then((doc) => {
          if (doc.exists) {
            // CHANGE STATS
            stats = doc.data();
            // CHNAGE STATS BASED ON ACCESS TAG
            if (
              this.getDetailBasic.tag === "G1" &&
              this.getDetailChar.tag === "C1"
            ) {
              stats.alockc = status;
              stats.alockct = this.getDetailChar.title;
              stats.alockcdid = this.getDetailChar.did;
            }
            if (
              this.getDetailBasic.tag === "G1" &&
              this.getDetailChar.tag === "F1"
            ) {
              stats.alockf = status;
              stats.alockft = this.getDetailChar.title;
              stats.alockfdid = this.getDetailChar.did;
            }

            // CHANGE FIREBASE USER ACCESS
            if (this.getDetailBasic.tag === "G1") {
              // GET USER ACCESS LIST
              this.userAccessList = [];
              let dbAccess = this.dbUserAccessUndefined;
              dbAccess = dbAccess.doc(userdid).collection("access");
              // eslint-disable-next-line
              dbAccess.get().then(querySnapshot => {
                  querySnapshot.forEach(doc => {
                    let docData = doc.data();
                    let obj = Object.assign({}, docData);
                    this.userAccessList.push(obj);
                  });
                })
                .then(() => {
                  // // CHANGE LOCK for SPECIFIC ACCESS
                  let tempUserAccess = this.changeListItemLockStatusRetrunItem(
                    !this.getDetailBasic.lock,
                    this.getDetailBasic.did,
                    this.userAccessList
                  );
                  // CHANGE USER ACCESS
                  let dbAccess = this.dbUserAccessUndefined;
                  dbAccess = dbAccess.doc(userdid).collection("access");
                  dbAccess = dbAccess.doc(tempUserAccess.basic.did);
                  dbAccess.set(tempUserAccess).then(() => {
                    // not required
                  });
                });
            }
            // CHANGE FIREBASE USER BASIC
            // eslint-disable-next-line
            db.doc(userdid).update(stats).then((doc) => {
                // baisc for access
                let basic = this.getDetailBasic;
                basic.lock = status;
                this.$store.dispatch("changeDetailBasic", basic);
                this.$store.dispatch("changeDataSavePendingIndication", true);
                this.btnSpinUserAccessLock = false;

                let msg = null;
                if (status === true) {
                  msg = "User Access was locked.";
                } else {
                  msg = "User Access was activated.";
                }
                this.generateInfoSnackbar(this.ui.colorBlue1, msg);
                // eslint-disable-next-line
            }).catch(error => {
                this.showSnackbar(error.message, "error");
              });
          } else {
            // t.showSnackbar("No Data", "error");
          }
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
      //
      // console.log("MODIFIED STATS");
      // console.log(stats);
    },
    changeFirebaseStatsRemote(tag, did, field, value, increment) {
      if (this.enableRelpsRemote(tag) === true) {
        let db = this.defineDataSourceFromTag("G5");
        let stats = null;
        let sign = 1;
        // CHANGE SIGN IF REQUIRED
        // eslint-disable-next-line
        if (increment === false) {
          sign = -1;
        }
        // eslint-disable-next-line
        // GET STATS REMOTE
        // eslint-disable-next-line
        db.doc(did).get().then((doc) => {
            // UPDATE HELP
            // console.log("");
            // console.log(">>> UPDATE STATS REMOTE <<<");
            // console.log("TAG     " + tag);
            // console.log("DID     " + did);
            // console.log("FIELD   " + field);
            // console.log("VALUE   " + value);
            // console.log("INCREM  " + increment);
            // console.log(doc.data());
            // DEFINE STATS
            stats = doc.data();
            // UPDATE LOG
            stats.n = stats.n + 1;
            stats.nd3 = stats.nd3 + 1;
            // CHANAGE STATS VALUES - INCREMENT
            if (increment === true) {
              if (stats.na1 !== undefined && field === "na1") {
                stats.na1 = stats.na1 + value * sign;
              }
              if (stats.nb1 !== undefined && field === "nb1") {
                stats.nb1 = stats.nb1 + value * sign;
              }
              if (stats.nc1 !== undefined && field === "nc1") {
                stats.nc1 = stats.nc1 + value * sign;
              }
              if (stats.nb3 !== undefined && field === "nb3") {
                stats.nb3 = stats.nb3 + value * sign;
                if (tag === "U1") {
                  stats.nb3o = stats.nb3o + value * sign;
                }
                if (tag === "C1") {
                  stats.nb3o = stats.nb3o + value * sign;
                }
              }
              if (stats.no1 !== undefined && field === "no1") {
                stats.no1 = stats.no1 + value * sign;
                if (tag === "F1") {
                  stats.no1o = stats.no1o + value * sign;
                }
              }
              if (stats.nb4 !== undefined && field === "nb4") {
                stats.nb4 = stats.nb4 + value * sign;
                // ONLY INCREMENT OPEN BUDGET FOR COMPANY ONLY
                if (tag === "C1") {
                  stats.nb4o = stats.nb4o + value * sign;
                }
              }
              if (stats.nb6 !== undefined && field === "nb6") {
                stats.nb6 = stats.nb6 + value * sign;
                // ONLY INCREMENT OPEN PLAN FOR COMPANY ONLY
                if (tag === "C1") {
                  stats.nb6o = stats.nb6o + value * sign;
                }
              }
              if (stats.nf1 !== undefined && field === "nf1") {
                stats.nf1 = stats.nf1 + value * sign;
              }
              if (stats.nl1 !== undefined && field === "nl1") {
                stats.nl1 = stats.nl1 + value * sign;
              }
              if (stats.nm2 !== undefined && field === "nm2") {
                stats.nm2 = stats.nm2 + value * sign;
              }
              if (stats.nm5 !== undefined && field === "nm5") {
                stats.nm5 = stats.nm5 + value * sign;
              }
              // if (stats.nm7 !== undefined && field === "nm7") {
              //   stats.nm7 = stats.nm7 + value * sign;
              // }
              if (stats.ns1 !== undefined && field === "ns1") {
                stats.ns1 = stats.ns1 + value * sign;
              }
              if (stats.ns6 !== undefined && field === "ns6") {
                stats.ns6 = stats.ns6 + value * sign;
                if (tag === "C1") {
                  stats.ns6o = stats.ns6o + value * sign;
                }
              }
              if (stats.ne1 !== undefined && field === "ne1") {
                stats.ne1 = stats.ne1 + value * sign;
              }
              if (stats.ne2 !== undefined && field === "ne2") {
                stats.ne2 = stats.ne2 + value * sign;
                // ONLY INCREMENT OPEN ACTION FOR COMPANY ONLY
                if (tag === "C1") {
                  stats.ne2o = stats.ne2o + value * sign;
                }
              }
              if (stats.ne6 !== undefined && field === "ne6") {
                stats.ne6 = stats.ne6 + value * sign;
              }
              if (stats.nq1 !== undefined && field === "nq1") {
                stats.nq1 = stats.nq1 + value * sign;
                // ONLY INCREMENT OPEN ACTION FOR COMPANY ONLY
                if (tag === "C1") {
                  stats.nq1o = stats.nq1o + value * sign;
                }
              }
              if (stats.nw1 !== undefined && field === "nw1") {
                stats.nw1 = stats.nw1 + value * sign;
                // ONLY INCREMENT OPEN ACTION FOR COMPANY ONLY
                if (tag === "F1") {
                  stats.nw1o = stats.nw1o + value * sign;
                }
              }
              if (stats.nw2 !== undefined && field === "nw2") {
                stats.nw2 = stats.nw2 + value * sign;
                if (
                  this.getAssetRegister !== null &&
                  this.getAssetRegister !== null
                ) {
                  if (this.getAssetRegister.length > 0) {
                    let assetCtr = this.getAssetRegister.length;
                    stats.nm7 = stats.nm7 + (value * sign) / assetCtr;
                  }
                }

                // ONLY INCREMENT OPEN ACTION FOR COMPANY ONLY
                if (tag === "F1") {
                  stats.nw2o = stats.nw2o + value * sign;
                }
              }
              if (stats.nw6 !== undefined && field === "nw6") {
                stats.nw6 = stats.nw6 + value * sign;
              }
              if (stats.nu1 !== undefined && field === "nu1") {
                stats.nu1 = stats.nu1 + value * sign;
              }
            }
            // CHANGE STATS DECREMENT
            if (increment === false) {
              if (stats.nb3o !== undefined && field === "nb3o") {
                // CLOSE ACTION ITEM OPEN ITEM
                if (stats.nb3o > 0) {
                  stats.nb3o = stats.nb3o + value * sign;
                }
              }
              if (stats.nb4o !== undefined && field === "nb4o") {
                // CLOSE BUDGET ITEM OPEN ITEM
                if (stats.nb4o > 0) {
                  stats.nb4o = stats.nb4o + value * sign;
                }
              }
              if (stats.nb6o !== undefined && field === "nb6o") {
                // CLOSE ACTION ITEM OPEN ITEM
                if (stats.nb6o > 0) {
                  stats.nb6o = stats.nb6o + value * sign;
                }
              }
              if (stats.ne2o !== undefined && field === "ne2o") {
                // CLOSE ACTION ITEM OPEN ITEM
                if (stats.ne2o > 0) {
                  stats.ne2o = stats.ne2o + value * sign;
                }
              }
              if (stats.ns6o !== undefined && field === "ns6o") {
                // CLOSE OPEN ITEM
                if (stats.ns6o > 0) {
                  stats.ns6o = stats.ns6o + value * sign;
                }
              }
              if (stats.no1o !== undefined && field === "no1o") {
                // CLOSE OPEN ITEM
                if (stats.no1o > 0) {
                  stats.no1o = stats.no1o + value * sign;
                }
              }
              if (stats.nq1o !== undefined && field === "nq1o") {
                // CLOSE OPEN ITEM
                if (stats.nq1o > 0) {
                  stats.nq1o = stats.nq1o + value * sign;
                }
              }
              if (stats.nw1o !== undefined && field === "nw1o") {
                // CLOSE OPEN ITEM
                if (stats.nw1o > 0) {
                  stats.nw1o = stats.nw1o + value * sign;
                }
              }
              if (stats.nw2o !== undefined && field === "nw2o") {
                // CLOSE OPEN ITEM
                if (stats.nw2o > 0) {
                  stats.nw2o = stats.nw2o + value * sign;
                }
              }
            }
            // HELP
            // console.log("");
            // console.log(">>> UPDATE STATS REMOTE <<<");
            // console.log(tag);
            // console.log(did);
            // console.log(stats);
            // UPDATE STATS
            // eslint-disable-next-line
            db.doc(did).update(stats).then().catch(error => {
                this.showSnackbar(error.message, "error");
              });
          })
          .catch(error => {
            this.showSnackbar(error.message, "error");
          });
      }
    },
    changeFirebaseDocumentUserPrefSelectReset(db, did) {
      // const db = this.defineDataSourceFromTag(tag);
      let t = this;
      console.log("FIREBASE DOC DIRECT CHANGE USER PREF SELECT");
      console.log(db);
      console.log(did);
      // eslint-disable-next-line
      db.doc(did)
        .update({
          "pref.select.cauth": null,
          "pref.select.cdid": "",
          "pref.select.cidg": "",
          "pref.select.cname": "",
          "pref.select.cshort": "",
          "pref.select.ctag": "",
          "pref.select.fauth": null,
          "pref.select.fdid": "",
          "pref.select.fidg": "",
          "pref.select.fname": "",
          "pref.select.fshort": "",
          "pref.select.ftag": ""
        })
        // eslint-disable-next-line
      .then().catch(error => {
          t.showSnackbar(error.message, "error");
        });
    }
  }
};
